import BaseSiteLayout from "../../layouts/BaseSiteLayout/BaseSiteLayout";
import Typography from "../../components/Typography/Typography";
import blogData from "../../routes/Blog/blogData.json"
import BlogCard from "../../routes/Blog/BlogCard"
import { Link } from "react-router-dom";

export default function Blog() {
    const { blogItems } = blogData;

    return (
        <BaseSiteLayout>

        <div className="flex flex-col gap-[80px] md:gap-[120px] pb-14">
            <Typography size="40" desktopSize="82" weight="sb" family="serif" color="black" align="center">
                Blog
            </Typography>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-9 w-full md:px-20">
                {[...blogItems]
                    .sort((a, b) => new Date(b.date) - new Date(a.date))
                    .map((blogItem) => (
                        <Link to={`/blog/${blogItem.id}`} key={blogItem.id}>
                            <BlogCard blogItem={blogItem} />
                        </Link>
                    ))}
            </div>
        </div>

        </BaseSiteLayout>
    )
}